import * as React from 'react';

function SvgTransmission(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M5 2.2a2.8 2.8 0 00-.8 5.484V12a.8.8 0 00.8.8h6.2v3.4c0 .039.003.076.008.114a2.801 2.801 0 101.584 0 .803.803 0 00.008-.114v-3.4h5.4v3.4c0 .039.003.076.008.114a2.801 2.801 0 101.584 0 .803.803 0 00.008-.114V7.8a.803.803 0 00-.008-.114A2.801 2.801 0 0019 2.2a2.8 2.8 0 00-.792 5.486.803.803 0 00-.008.114v3.4h-5.4V7.8a.803.803 0 00-.008-.114A2.801 2.801 0 0012 2.2a2.8 2.8 0 00-.792 5.486.803.803 0 00-.008.114v3.4H5.8V7.684A2.801 2.801 0 005 2.2z" })));
}

export default SvgTransmission;
